// import React from "react";

// const WhatsAppButton = () => {
//   const handleClick = () => {
//     // 👉 Option 1: Simple open WhatsApp chat (wa.me link)
//     window.open("https://wa.me/919876543210?text=Hi%20I%20want%20to%20know%20more", "_blank");

//     // 👉 Option 2: If you want to trigger backend (wabridge API)
//     // fetch("http://localhost:4000/api/send-whatsapp", {
//     //   method: "POST",
//     //   headers: { "Content-Type": "application/json" },
//     //   body: JSON.stringify({
//     //     device_id: "YOUR_DEVICE_ID",
//     //     message: "Hello! I want to chat with you.",
//     //     phone: "919876543210"
//     //   }),
//     // })
//     // .then(res => res.json())
//     // .then(data => console.log("WhatsApp API Response:", data))
//     // .catch(err => console.error("Error:", err));
//   };

//   return (
//     <div
//       onClick={handleClick}
//       className="fixed bottom-5 right-5 bg-green-500 p-4 rounded-full shadow-lg cursor-pointer hover:bg-green-600 z-50"
//     >
//       <img
//         src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
//         alt="WhatsApp"
//         className="w-8 h-8"
//       />
//     </div>
//   );
// };

// export default WhatsAppButton;


// import React from "react";

// const WhatsAppButton = () => {
//   const sendMessage = async () => {
//     try {
//       const response = await fetch("https://web.wabridge.com/api/createtextmessage", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           "app-key": "317e2575-03e7-4ee8-8681-43a94b992703",
//           "auth-key": "0ad02f6ced0a63b1aee3fae3824fdeb1ab5d9a100c1b7e935e",
//           "destination_number": "919156953175", // 👈 customer number with country code
//           "device_id": "68afe82d61cfac14b5029afc",       // 👈 replace with your device_id
//           "message": "Hello! I want to chat with Mammoth Streetwear 👕🔥",
//         }),
//       });

//       const result = await response.json();
//       console.log("API Response:", result);

//       if (result.status) {
//         alert("✅ WhatsApp message sent successfully!");
//       } else {
//         alert("❌ Failed: " + result.message);
//       }
//     } catch (error) {
//       console.error("Error sending message:", error);
//       alert("⚠️ Something went wrong. Check console.");
//     }
//   };

//   return (
//     <div
//       onClick={sendMessage}
//       className="fixed bottom-5 right-5 bg-green-500 p-4 rounded-full shadow-lg cursor-pointer hover:bg-green-600 z-50"
//     >
//       <img
//         src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
//         alt="WhatsApp"
//         className="w-8 h-8"
//       />
//     </div>
//   );
// };

// export default WhatsAppButton;


import React from "react";

const WhatsAppButton = () => {
  const openWhatsApp = () => {
    const phoneNumber = "919156953175";
    const message = "Hello! I want to chat with Mammoth Streetwear 👕🔥";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div
      onClick={openWhatsApp}
      style={{ width: "64px", height: "64px" }}
      className="fixed bottom-5 right-5 z-[9999] flex items-center justify-center bg-green-500 p-4 rounded-full shadow-lg cursor-pointer hover:bg-green-600 transition-transform duration-200 hover:scale-105"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        width="32"
        height="32"
        className="w-8 h-8 object-contain"
        loading="lazy"
      />
    </div>
  );
};

export default WhatsAppButton;


